let tipsListByPathname = {
    '/company-registration-extended/index': {
        'top': {
            title: 'Manager tip',
            text: 'Our quick 5 minute 5 step account setup will give you the basics you need to start using our apps with your devices. You can change or add any details go to our account settings page',
        },
        // 'center': {
        //     title: 'Ecommerce insights',
        //     text: 'Did you know ecommerce  website using sales support software like webliveview  achieved improved sales conversion rates of 20%-30% and increased order values of 200- 300 %  engaging with their online customers enquiry over 12 months of using it.',
        // }
    },
    '/company-registration-extended/business-details': {
        'top': {
            title: 'Manager tip',
            text: 'The widget business name is your brand name the same name as your website address which will appear on the widget on your website Your company logo must be in a jpeg file format when uploaded',
        },
    },
    '/company-registration-extended/team-details': {
        'top': {
            title: 'Manager tip',
            text: 'Your team profile photos which you can upload here or the team section in account settings page our seen by your customers on your website we recommend a professional photo quality with a white background in a bright lit room to get the best effect. <br>For your team members to start using our apps from the App Store or google play store their app log in email address and password for a member will have to be added here. We recommend you make the passwords easy to remember by your staff. ',
        },
    },
    '/company-registration-extended/widget-functions': {
        'top': {
            title: 'Manager tip',
            text: 'To match the exact brand colours of our widget with your own ecommerce website page colours Ask your web developer for the hex numbers used for your website (colour palette number) .Can be added after your account is set up in widget settings account settings page access to it from your login to the manager dashboard.',
        },
    },
    '/company-registration-extended/thanks': {
        'top': {
            title: 'Manager tip',
            text: 'Our system and apps will not work correctly until your account widget code is copied to your websites home page. Once the widget installed you can start receiving webchat messages and see and experience our video chat calls with your staff and customers',
        },
        // 'center': {
        //     title: 'Ecommerce buyers insights ',
        //     text: '38% of online buyers new to a brand will only buy from a brand or ecommerce website that has sales support like live chat when buying a large purchase online',
        // },
    },
};

$(document).ready(function () {
    if(tipsListByPathname[window.location.pathname] == undefined){
        return true;
    }

    if(tipsListByPathname[window.location.pathname].top != undefined){
        $('#registrationTipTopModal .modal-body .title').html(tipsListByPathname[window.location.pathname].top.title);
        $('#registrationTipTopModal .modal-body .text').html(tipsListByPathname[window.location.pathname].top.text);
        $('#registrationTipTopModal').modal('show'); 
    }

    if(tipsListByPathname[window.location.pathname].center != undefined){
        $('#registrationTipCenterModal .modal-body .title').html(tipsListByPathname[window.location.pathname].center.title);
        $('#registrationTipCenterModal .modal-body .text').html(tipsListByPathname[window.location.pathname].center.text);
        $('#registrationTipCenterModal').modal('show');
    }
});